export default "__VITE_ASSET__5c45713e__"